export default "__VITE_ASSET__DXHXXg6c__"